module.exports = __webpack_public_path__ + "static/assets/c825dcd4acb9b471c048a41be180996e.svg";